import React, { useContext, useState } from "react";
import { InvoiceFilters } from "../../common/contracts/invoice.contract";
import { Pagination } from "../general/Pagination/Pagination";
import { InvoicesByCounterpartyTable } from "./InvoicesByCounterpartyTable";
import { InvoicesByCounterpartyTableContext } from "./InvoicesByCounterpartyTableContextProvider";
import { InvoicesDrilldownModal } from "./InvoicesDrilldownModal";

export const InvoicesByCounterpartyTableContainer: React.FC = () => {
    const {
        data: invoicesByCounterparty = [],
        isLoading,
        currentSort,
        handleSortChange,
        totalPages,
        currentPage,
        setPage,
        counterpartiesCount,
    } = useContext(InvoicesByCounterpartyTableContext);

    const [drilldownParams, setDrilldownParams] = useState<InvoiceFilters>();

    const onDrilldown = (params: InvoiceFilters) => {
        setDrilldownParams(params);
    };

    return (
        <>
            <InvoicesByCounterpartyTable
                invoicesByCounterparty={invoicesByCounterparty}
                sort={currentSort}
                onSortChange={handleSortChange}
                isLoading={isLoading}
                onDrilldown={onDrilldown}
                counterpartiesCount={counterpartiesCount}
                pagination={
                    <Pagination
                        pageCount={totalPages}
                        currentPage={currentPage}
                        onPageChange={setPage}
                    />
                }
            />
            <InvoicesDrilldownModal
                show={!!drilldownParams}
                onHide={() => setDrilldownParams(undefined)}
                filters={drilldownParams}
            />
        </>
    );
};
